import * as React from 'react';
import { observer } from 'mobx-react';

import TextHighlighter from 'shared/components/TextHighlighter';
import { IWidgetChannelModel } from 'shared/entities/channels/client';
import { ComponentType } from 'shared/entities/components/Component';
import { useTypedTranslation } from 'shared/entities/localization';
import { Button } from 'shared/newComponents/buttons';
import Snippet from 'shared/newComponents/Snippet';
import Typography from 'shared/newComponents/Typography';
import { ButtonSize } from 'shared/newEntities/components/Button';
import {
  TypographyType,
  TypographySize,
  TypographyColor
} from 'shared/newEntities/components/Typography';

import './WidgetSnippet.modules.scss';

type Props = {
  channel: IWidgetChannelModel;
};

const WidgetSnippet: React.FC<Props> = ({ channel }) => {
  const { t } = useTypedTranslation('newContainers');

  return (
    <div styleName="widget-snippet">
      <Snippet
        styleName="widget-snippet__snippet"
        code={channel.generatedSnippet}
        Instruction={
          <Typography
            fontType={TypographyType.text}
            fontSize={TypographySize.s}
            fontColor={TypographyColor.secondary}
          >
            <TextHighlighter
              text={t(
                'ChannelsModal.SelectedChannel.Content.Widget.Snippet.description'
              )}
              query={['</body>']}
              highlightWithColor={false}
            />
          </Typography>
        }
      />
      <div className="widget-snippet__footer">
        <Button
          size={ButtonSize.s}
          type={ComponentType.button}
          onClick={() => channel.checkInstall()}
          isLoading={channel.isChecking}
          disabled={channel.isInstallCheckBlocked}
        >
          {t(
            'ChannelsModal.SelectedChannel.Content.Widget.Snippet.checkButton'
          )}
        </Button>
      </div>
    </div>
  );
};

export default observer(WidgetSnippet);
